// extracted by mini-css-extract-plugin
export var contrastLow = "_8-1";
export var externalLink = "_8-2";
export var externalLinkIcon = "_8-3";
export var link = "_8-0";
export var linkLabel = "_8-4";